import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import OtpRedirectPage from 'components/pages/OtpRedirectPage/OtpRedirectPage';
import OrderStatusPage from 'components/pages/OrderStatusPage/OrderStatusPage';
import Layout from './components/layout/Layout/Layout';
import OrderPage from './components/pages/OrderPage/OrderPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/orders/:orderRef">
            <Route index element={<OrderPage />} />
            <Route path="/orders/:orderRef/status" element={<OrderStatusPage />} />
          </Route>
          <Route path="/otpredirect" element={<OtpRedirectPage />} />
        </Route>
      </Routes>
    </QueryClientProvider>
  );
}

export default App;
